export default __webpack_public_path__ + "static/media/create-quiz.46fcc819.webp";